export default {"src":"/_next/static/media/link.bd8ddac7.svg","height":100,"width":100};